export default {
      id: "sort_desc-usage",
      viewBox: "0 0 15 18",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#sort_desc",
      toString: function () {
        return this.url;
      }
    }